import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class DealSizePage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="container">
        <div className="well">
          <code>
            TODO: Deal Size Leaderboard
          </code>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {
  };
}

DealSizePage.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

DealSizePage.defaultProps = {
};

DealSizePage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(DealSizePage);
